import {
  compose,
  withProps,
  withHandlers,
  withStateHandlers,
} from 'recompose';
import { withModal } from '../Common/Modal/Modal';
import Preview, { withIssuuId } from './Preview';

export const CONFIG = { attributes: true, childList: true, subtree: true };
export const ORIENTATIONS = ['landscape', 'portrait', 'square'];
export const GALLERY_NODE_ID = '.GalleryViewMain';

const withSelectedType = compose(
  withStateHandlers(({
    selectedType = '',
    open = false,
    isGalleryFound = false
  }) => ({
    selectedType,
    open,
    isGalleryFound
  }), {
    setSelectedType: ({ selectedType }) => ({ insertedType }) => {
      const selected = ORIENTATIONS.find(e => !!document.querySelector(`.tab.${e}.selected`)) || 'default';
      if (insertedType) {
        return { selectedType: insertedType };
      }
      if (selectedType !== selected) {
        return { selectedType: selected };
      }
      return undefined;
    },
    setOpen: () => () => ({ open: true }),
    closeCallback: () => () => ({ open: false }),
    setGalleryFound: () => status => ({ isGalleryFound: status }),
  }),
);

export const withPreviewHandler = compose(
  withHandlers({
    findGalleryNode: ({ setGalleryFound }) => (mutationList, observer) => {
      const element = document.querySelector(GALLERY_NODE_ID);
      setGalleryFound(!!element);
    },
    replaceDescription: ({ startProjectProductAttributes }) => (mutationList, observer) => {
      const { product_config = '' } = startProjectProductAttributes;
      const elem = document.getElementsByClassName('_customHtml');
      if (elem.length > 0 && product_config) {
        const node = document.createElement('span');
        const htmltrans = document.createElement('HTMLTrans');
        const textnode = document.createTextNode('\n We’ve configured this project to your voucher. \n' +
          'Any settings adjustments made will make your voucher unusable.');
        htmltrans.setAttribute('id', 'PdpPreview_start-project_description');
        const customHtml = elem[0];
        htmltrans.appendChild(textnode);
        node.appendChild(htmltrans);
        customHtml.appendChild(node);
        customHtml.parentNode.insertBefore(node, customHtml);
        customHtml.parentNode.removeChild(customHtml);
      }
    },
  }),
);

export const withMutationObserverHandler = compose(
  withHandlers({
    injectPdpPreview: ({ findGalleryNode, setSelectedType, replaceDescription }) => (targetNode) => {
      const findGalleryObserver = new MutationObserver(findGalleryNode);
      const watchOrientationObserver = new MutationObserver(setSelectedType);
      const replaceDescriptionObserver = new MutationObserver(replaceDescription);
      findGalleryObserver.observe(targetNode, CONFIG);
      watchOrientationObserver.observe(targetNode, CONFIG);
      replaceDescriptionObserver.observe(targetNode, CONFIG);
    }
  })
);

const withModalBody = compose(
  withProps({
    size: 'lg',
    modalBody: Preview,
  }),
);

export const withPdpPreview = compose(
  withModalBody,
  withSelectedType,
  withIssuuId,
  withPreviewHandler,
  withMutationObserverHandler,
  withModal,
);



// WEBPACK FOOTER //
// ./src/IssuuPreview/withPdpPreview.js